import { THINKING_TYPE_PROCESSING } from "common/constants/v2/Constants";

// Actions (must be name-spaced for reducer)

export const SET_THINKING = "SET_THINKING";
export const DONE_THINKING = "DONE_THINKING";

// Reducer

export function thinkingReducer(thinking = null, action = {}) {
    switch (action.type) {
        case SET_THINKING:
            return action.thinkingType;
        case DONE_THINKING:
            return null;
        default:
            return thinking;
    }
}

// Action Creators

export function setThinking(thinkingType = THINKING_TYPE_PROCESSING) {
    return {
        type: SET_THINKING,
        thinkingType
    };
}

export function doneThinking() {
    return {
        type: DONE_THINKING
    };
}

export default {
    thinkingReducer,
    setThinking,
    doneThinking
};
